import {getAllProducts, updateInventoryAlert} from "../../api/Api";
import {useEffect, useRef, useState} from 'react';
import {Button, Col, Popover, Modal, InputNumber, Row, Table, message} from "antd";
import {CategoryType, UnitType, ProductType, ProductSubType} from "../../api/Constants";
import {insertInventory} from "../../api/Api";
import {getColumnSearchProps} from "../widget/SearchProps";
import {Link} from 'react-router';
import {toUtcDateString} from "../../util/timeutils";

const generateDateSku = (name, description) => {
    const result = `${toUtcDateString(new Date())}-${name}-${description}`;
    return result.replaceAll(" ", "-");
}

export const ProductTable = ({onApiFail, refresh, onRefresh, props}) => {
    const [inventory, setInventoryList] = useState([]);

    const [cost, setCost] = useState(undefined);

    const [shipping, setShipping] = useState(0);
    const [tariff, setTariff] = useState(0);
    const [alertQuantity, setAlertQuantity] = useState(undefined);

    const [product, setProduct] = useState(undefined);
    const [inventoryQuantity, setInventoryQuantity] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [messageApi, contextHolder] = message.useMessage();

    const unit = UnitType.Each;

    useEffect(() => {
        getAllProducts().then((x) => {
            console.log(x);
            const tableData = x.map((val, index) => {
                return {...val, key: index}
            });
            console.log(tableData);
            setInventoryList(tableData);
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [refresh, onApiFail]);


    const searchInput = useRef(null);

    const onCostChange = (val) => {
        setCost(val);
    }

    const onShippingChange = (val) => {
        setShipping(val);
    }

    const onTariffChange = (val) => {
        setTariff(val);
    }

    const onQuantityChange = (val) => {
        setInventoryQuantity(val);
    }

    const onAlertQuantityChange = (val) => {
        setAlertQuantity(val);
    }

    const clearInputs = () => {
        setInventoryQuantity(0);
        setCost(undefined);
        setShipping(0);
        setTariff(0);
        setAlertQuantity(undefined)
    }

    const quantityInvalid = (inventoryQuantity === 0) || (inventoryQuantity === undefined) || (inventoryQuantity === null);
    const alertInvalid = (alertQuantity === undefined) || (alertQuantity === null);
    const costInvalid= (cost === undefined) || (cost === null);
    const dialogOkDisabled = quantityInvalid || alertInvalid || costInvalid;

    const inventoryUI = (category) => {

        const productInventoryUI =  <div>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><InputNumber min={0} precision={0} placeholder={"Quantity"} onChange={onQuantityChange} /></Col>
            </Row>
            <Row gutter={[16, 22]} style={{textAlign: 'left', paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><InputNumber min={0} precision={2} placeholder={'cost'} addonBefore={"Cost $"} onChange={onCostChange} value={cost} /></Col>
            </Row>
        </div>

        const supplyInventoryUI = <div>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><InputNumber min={0} placeholder={"Quantity"} onChange={onQuantityChange} /></Col>
            </Row>
            <Row gutter={[16, 22]} style={{textAlign: 'left', paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><InputNumber min={0} precision={2} placeholder={'price'} addonBefore={"Price $"} onChange={onCostChange} value={cost}/></Col>
            </Row>
            <Row gutter={[16, 22]} style={{textAlign: 'left', paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><InputNumber min={0} precision={2} placeholder={'shipping'} addonBefore={"Shipping Cost $"} onChange={onShippingChange} value={shipping} /></Col>
            </Row>
            <Row gutter={[16, 22]} style={{textAlign: 'left', paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><InputNumber min={0} precision={2} placeholder={'tariff'} addonBefore={"Tariff $"} onChange={onTariffChange} value={tariff} /></Col>
            </Row>
            <Row gutter={[16, 22]} style={{textAlign: 'left', paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={12}><InputNumber min={0} precision={0} placeholder={'Alert'} addonBefore={"Low Inventory Alert"} onChange={onAlertQuantityChange} value={alertQuantity} /></Col>
            </Row>
        </div>

        if (category === CategoryType.Supplies) {
            return supplyInventoryUI;
        } else {
            return productInventoryUI;
        }
    }

    const onCancel = () => {
        clearInputs();
        setIsModalOpen(false);
    }

    const onInventoryClick = () => {
        clearInputs();
        setIsModalOpen(false);

        insertInventory(product.id, inventoryQuantity, product.category, {
            sku: generateDateSku(product.name, product.description), unit, cost, shipping, tariff
        }).then(res => {
            if (product.category === CategoryType.Supplies) {
                updateInventoryAlert(res.id, alertQuantity, true).then(r => {
                    console.log(`updated supply alert`);
                }).catch(e => {
                    console.log(e);
                });
            }
            if (onRefresh) onRefresh();
            messageApi.open({
                type: 'success',
                content: `Inventory updated`
            });
        }).catch(e => {
            messageApi.open({
                type: 'error',
                content: `Failed to create Inventory`
            });
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const setModalOpen = (product) => () => {
        setProduct(product);

        setIsModalOpen(true);
    }

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (val, record, index) => {
                return <Popover content={'View Product'}>
                    <Link to={`/product/${encodeURIComponent(record.id)}`}>{val}</Link>
                </Popover>
            },
            sorter: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
            ...getColumnSearchProps('name', searchInput)
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            render: (val, record, index) => {
                return CategoryType.Label[val];
            },
            sorter: (a, b) => a.category - b.category
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            render: (val, record, index) => {
                return ProductType.Label[val]
            },
            sorter: (a, b) => a.type - b.type,
        },
        {
            title: 'Sub Type',
            dataIndex: 'subtype',
            key: 'subtype',
            render: (val, record, index) => {
                return ProductSubType.Label[val];
            },
            sorter: (a, b) => a.subtype - b.subtype,
        },
        {
            title: 'Sku',
            dataIndex: 'sku',
            key: 'sku'
        },
        {
            title: 'Add Inventory',
            dataIndex: 'name',
            key: 'inventory',
            render: (val, record, index) => {
                if (record.category === CategoryType.Wholesale) {
                    return <Popover content={'Use the Batch/Wholesale tool to add new Inventory'}>
                        <div>Wholesale</div>
                    </Popover>
                }

                if (record.category === CategoryType.Packaged) {
                    return <Popover content={'Use the Fulfillment Tab to Create Packaged Inventory'}>
                        <div>Fulfillment</div>
                    </Popover>
                }

                if (record.category === CategoryType.Supplies) {
                    return <Popover content={'Add this product to Inventory'}>
                        <Button onClick={setModalOpen(record)}>
                            Add Inventory
                        </Button>
                    </Popover>
                }
            }
        }
    ];

    const tablePagination = {
        defaultPageSize: 50,
        showSizeChanger: true,
        pageSizeOptions: [50, 100, 150, 200]
    }

    return <div>
        {contextHolder}
        <Modal title={'Add Products to Inventory'} open={isModalOpen} onCancel={onCancel} onOk={onInventoryClick} okButtonProps={{disabled: dialogOkDisabled}}>
            {product && inventoryUI(product.category)}
        </Modal>
        <Table dataSource={inventory} columns={columns} pagination={tablePagination}/>
    </div>
}